var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.259,
    height: 16.745,
    viewBox: "0 0 11.259 16.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Make_Default",
    "data-name": "Make Default",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_156",
    "data-name": "Line 156",
    y2: 14.823,
    transform: "translate(0 1.422)",
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_14",
    "data-name": "Polygon 14",
    d: "M4.277,1.872a1,1,0,0,1,1.8,0L9.666,9.326a1,1,0,0,1-.9,1.434H1.591a1,1,0,0,1-.9-1.434Z",
    transform: "translate(10.759) rotate(90)",
    fill: "#ff7e7e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/Default.00b61b34cd8edd372ede3cf68cab5f1f.svg";
export { ForwardRef as ReactComponent };